
import { Component, Vue } from 'vue-property-decorator'
import { AccountService } from "@/services/account/AccountService"
import { State } from "vuex-class"
import User from "@/types/account/user"
import { LOCALES, Locales } from "@/types/locales/locales"
import ColorPicker from "@/components/Settings/ColorPicker.vue"

@Component({
  components: {
    ColorPicker
  }
})
export default class Presentation extends Vue {
  private accountService: AccountService = new AccountService();
  private file: File | null = null
  private companyLogo: File | null = null
  private loading = false
  private activeMode = 2
  private availableLanguages = LOCALES
  private activeLanguage = 0

  @State((state: any) => state.user, { namespace: 'account' })
  private user!: User;

  created () {
    const darkTheme = this.$store.getters['global/isDarkTheme']
    if (darkTheme !== null && darkTheme) {
      this.activeMode = 1
    }
    if (darkTheme !== null && !darkTheme) {
      this.activeMode = 0
    }
    this.activeLanguage = LOCALES.findIndex((object) => {
      return object.value === this.$i18n.locale
    })
  }

  private upload () {
    this.loading = true
    if (this.file) {
      this.accountService.uploadProfilePicture(this.file, this.user?.profilePicture)
        .then((profilePicture) => {
          this.$store.commit('account/setProfilePicture', profilePicture)
        })
        .catch((error) => {
          this.$store.dispatch('error/setError', error)
        }).finally(() => {
          this.loading = false
        })
    }
  }

  private uploadCompanyLogo () {
    this.loading = true
    if (this.companyLogo) {
      this.accountService.uploadCompanyLogo(this.companyLogo, this.user?.companyLogo)
        .then((companyLogo) => {
          this.$store.commit('account/setCompanyLogo', companyLogo)
        })
        .catch((error) => {
          this.$store.dispatch('error/setError', error)
        }).finally(() => {
          this.loading = false
        })
    }
  }

  private uploadCompanyColor (colorCode: string) {
    if (!colorCode) return
    this.loading = true
    this.accountService.uploadCompanyColor(colorCode)
      .then((color) => {
        this.$store.commit('account/setCompanyColor', color)
      })
      .catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.loading = false
      })
  }

  private themeSwitch (theme: boolean | null) {
    if (theme !== null) {
      this.$vuetify.theme.dark = theme
    } else {
      this.$vuetify.theme.dark = window.matchMedia("(prefers-color-scheme: dark)").matches
    }
    this.$store.dispatch("global/setTheme", theme)
  }

  private get profilePicture () {
    return process.env.VUE_APP_STORAGE_BASE_URL + this.user.profilePicture
  }

  private get companyLogoUrl () {
    return process.env.VUE_APP_STORAGE_BASE_URL + this.user.companyLogo
  }

  private get previewAvatar () {
    return URL.createObjectURL(this.file)
  }

  private get previewCompanyLogo () {
    return URL.createObjectURL(this.companyLogo)
  }

  private changeCurrentLanguage (item: any) {
    this.$store.dispatch("global/setLanguage", item.value.toUpperCase() as Locales)
    this.$i18n.locale = item.value
  }
}
